import mapboxgl from "mapbox-gl";

const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1Ijoiam9zZXBoMDcxMDIwMDQiLCJhIjoiY203Z3Y1ODBtMGlpdDJqcHo3amc5cGk5dyJ9.W1hvzjt9eqIy8lU5tVA3aA";

mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

export default mapboxgl;
